import CharacterForm from './CharacterForm'
export default CharacterForm